// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-version-container {
    display: flex;
    justify-content: center;
    align-content: center;
    flex-flow: column;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    /* width: 65%; */
}

h2 {
    margin-top: 40px;
    margin-bottom: 0px;
}

.MuiTableContainer-root {
    margin-top: 40px !important;
}


@media (max-width: 768px) {
    .app-version-container {
        width: 85%;
    }
    table td {
        display: block;
        border-bottom: 1px solid gray;
    }
}

/* React Quill Editor Styling */
.ql-container {
    font-family: inherit;
    font-size: 14px;
}

.ql-editor {
    min-height: 250px;
    max-height: 300px;
    overflow-y: auto;
}

.ql-toolbar {
    background-color: #f5f5f5;
    border-radius: 4px 4px 0 0;
}

.ql-container {
    border-radius: 0 0 4px 4px;
}

/* Make the editor look better in the dialog */
.ql-editor.ql-blank::before {
    color: #999;
    font-style: italic;
}

/* Blog post content styling */
.blog-content p {
    margin: 0.5em 0;
}

.blog-content h1, .blog-content h2, .blog-content h3 {
    margin: 0.3em 0;
}

.blog-content ul, .blog-content ol {
    margin: 0.5em 0;
    padding-left: 1.5em;
}

.blog-content a {
    color: #08C47C;
    text-decoration: underline;
    cursor: pointer;
    transition: all 0.2s ease;
}

.blog-content a:hover {
    opacity: 0.8;
    text-decoration: none;
}

.ql-editor a {
    color: #08C47C;
    text-decoration: underline;
}

.ql-snow .ql-tooltip {
   left: 0 !important;
}

/* YouTube embed styling */
.blog-content iframe {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/dashboard/components/appversion.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI;QACI,UAAU;IACd;IACA;QACI,cAAc;QACd,6BAA6B;IACjC;AACJ;;AAEA,+BAA+B;AAC/B;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,8CAA8C;AAC9C;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA,8BAA8B;AAC9B;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;GACG,kBAAkB;AACrB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,wCAAwC;AAC5C","sourcesContent":[".app-version-container {\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    flex-flow: column;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    /* width: 65%; */\n}\n\nh2 {\n    margin-top: 40px;\n    margin-bottom: 0px;\n}\n\n.MuiTableContainer-root {\n    margin-top: 40px !important;\n}\n\n\n@media (max-width: 768px) {\n    .app-version-container {\n        width: 85%;\n    }\n    table td {\n        display: block;\n        border-bottom: 1px solid gray;\n    }\n}\n\n/* React Quill Editor Styling */\n.ql-container {\n    font-family: inherit;\n    font-size: 14px;\n}\n\n.ql-editor {\n    min-height: 250px;\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.ql-toolbar {\n    background-color: #f5f5f5;\n    border-radius: 4px 4px 0 0;\n}\n\n.ql-container {\n    border-radius: 0 0 4px 4px;\n}\n\n/* Make the editor look better in the dialog */\n.ql-editor.ql-blank::before {\n    color: #999;\n    font-style: italic;\n}\n\n/* Blog post content styling */\n.blog-content p {\n    margin: 0.5em 0;\n}\n\n.blog-content h1, .blog-content h2, .blog-content h3 {\n    margin: 0.3em 0;\n}\n\n.blog-content ul, .blog-content ol {\n    margin: 0.5em 0;\n    padding-left: 1.5em;\n}\n\n.blog-content a {\n    color: #08C47C;\n    text-decoration: underline;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.blog-content a:hover {\n    opacity: 0.8;\n    text-decoration: none;\n}\n\n.ql-editor a {\n    color: #08C47C;\n    text-decoration: underline;\n}\n\n.ql-snow .ql-tooltip {\n   left: 0 !important;\n}\n\n/* YouTube embed styling */\n.blog-content iframe {\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
